import controller from './details-chart.controller';

const template = require('./details-chart.html');

export default {
    bindings: {
        chartData: '<',
        chartType: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/details-chart/details-chart.component.js